import { ApiState } from "../../common/constants/api-constants";

export enum AbandonedCartPreferenceStatus {
  subscribed = 'subscribed',
  unsubscribed = 'unsubscribed',
  alreadyUnsubscribed = 'alreadyUnsubscribed',
}

declare interface ShareCartResponse {
  status: AbandonedCartPreferenceStatus;
}

export enum AbandonedCartPreferenceActions {
  get = 'get',
  subscribe = 'subscribe',
  unsubscribe = 'unsubscribe',
}

export declare interface AbandonedCartPreferenceState extends ApiState {
  data: ShareCartResponse;
}

export declare interface AbandonedCartPreferenceParams {
  token: string;
  action: AbandonedCartPreferenceActions;
}
